import React, { useState, useEffect } from 'react'
import DateTimePicker from 'react-datetime-picker'
import moment from 'moment'
import CalendarIcon from '../Resources/svg/date-picker.svg'

interface DatePickerProps {
  name: string;
  register?: any;
  defaultValue?: any;
  value?: any;
  onChange?: (date: any) => void;
  onValidationError?: (error: string | null) => void;
  validateDate?: (date: any) => string | null;
  format?: string;
  disabled?: boolean;
  className?: string;
  maxDate?: Date;
}

const DatePicker: React.FC<DatePickerProps> = ({
  name,
  register,
  defaultValue,
  value,
  onChange,
  onValidationError,
  validateDate,
  format = "dd-MM-yy",
  disabled = false,
  className = "",
  maxDate = new Date()
}) => {
  const [selectDate, setSelectDate] = useState<any>(null);
  const [errorDate, setErrorDate] = useState<string | null>(null);

  useEffect(() => {
    if (defaultValue) {
      setSelectDate(moment(defaultValue, "DD/MM/YYYY").toDate());
    } else if (value) {
      setSelectDate(value);
    }
  }, [defaultValue, value]);

  const handleDateChange = (date: any) => {
    setSelectDate(date);
    
    if (validateDate && date) {
      const error = validateDate(date);
      setErrorDate(error);
      if (onValidationError) {
        onValidationError(error);
      }
    } else {
      setErrorDate(null);
      if (onValidationError) {
        onValidationError(null);
      }
    }

    if (onChange) {
      onChange(date);
    }
  };

  return (
    <>
      <div className={`datapicker-single ${errorDate && "is-error"} ${className}`}>
        <div className="datapicker-single__body">
          <DateTimePicker
            name={name}
            value={selectDate}
            format={format}
            dayPlaceholder="dd"
            monthPlaceholder="mm"
            yearPlaceholder="yy"
            onChange={handleDateChange}
            disabled={disabled}
            maxDate={maxDate}
            calendarIcon={<img src={CalendarIcon} alt="calendar" />}
            clearIcon={null}
          />
        </div>
      </div>
      {register && (
        <input
          type="hidden"
          name={name}
          value={selectDate ? moment(selectDate).format("DD/MM/YYYY") : ""}
          ref={register}
        />
      )}
      {errorDate && <div className="errorCustom">{errorDate}</div>}
    </>
  )
}

export default DatePicker